export default __webpack_public_path__ + "static/media/logo_small.5b110336.jpg";